import UserNotes from './UserNotes';

export default UserNotes;
